// This file is kept for backward compatibility
// New code should use useLanguage hook from LanguageProvider
// Re-export from LanguageProvider for existing consumers

import { createContext } from "react";

const initialState = {
    language: "english",
  setLanguage: () => {},
  languages: [],
  isLanguageLoading: true,
  };

const LanguageContext = createContext(initialState);

export default LanguageContext;
